import { useState } from 'react';

function TestimonialForm() {
  const [form, setForm] = useState({
    customerName: '',
    text: '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!form.customerName.trim() || !form.text.trim()) {
      setMessage('Please enter both your name and your testimonial.');
      return;
    }

    try {
      setLoading(true);
      setMessage('');

      const response = await fetch('/api/testimonials', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          customerName: form.customerName.trim(),
          text: form.text.trim(),
        }),
      });

      if (!response.ok) {
        const payload = await response.json();
        throw new Error(payload.error || 'Failed to submit testimonial.');
      }

      setSubmitted(true);
      setForm({ customerName: '', text: '' });
      setMessage('Thank you for your feedback. Your testimonial will be reviewed and published shortly.');

      setTimeout(() => {
        setSubmitted(false);
        setMessage('');
      }, 5000);
    } catch (error) {
      setMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="content-page-block testimonial-form-section">
      <h3 className="testimonial-form-title">Share Your Experience</h3>
      <p className="testimonial-form-text">
        Have you purchased from M.J. Motors? We would love to hear about your experience.
      </p>

      {message && <p className={`status-text ${submitted ? 'submission-success' : ''}`}>{message}</p>}

      <form className="testimonial-form" onSubmit={handleSubmit} noValidate>
        <label className="testimonial-form-field">
          <span>Your Name</span>
          <input
            type="text"
            name="customerName"
            placeholder="Your full name"
            value={form.customerName}
            onChange={handleChange}
            disabled={loading}
            maxLength="100"
            required
          />
        </label>

        <label className="testimonial-form-field">
          <span>Your Review</span>
          <textarea
            name="text"
            placeholder="Tell us about your experience with M.J. Motors..."
            value={form.text}
            onChange={handleChange}
            disabled={loading}
            maxLength="500"
            rows="4"
            required
          />
        </label>

        <button type="submit" className="testimonial-submit-btn" disabled={loading}>
          {loading ? 'Submitting...' : 'Submit Testimonial'}
        </button>
      </form>
    </section>
  );
}

export default TestimonialForm;
